const locales: Record<string, string> = {
  AED: 'ar-AE',
  AOA: 'pt-AO',
  AND: 'ca-AD',
  ARS: 'es-AR',
  AUD: 'en-AU',
  BDT: 'bn-BD',
  BGN: 'bg-BG',
  BOB: 'es-BO',
  BRL: 'pt-BR',
  CAD: 'en-CA',
  CDF: 'fr-CD',
  CLP: 'es-CL',
  CNY: 'zh-CN',
  COP: 'es-CO',
  CZK: 'cs-CZ',
  DKK: 'da-DK',
  EGP: 'ar-EG',
  ETB: 'am-ET',
  EUR: 'de-DE',
  GBP: 'en-GB',
  GHS: 'en-GH',
  GTQ: 'es-GT',
  HNL: 'es-HN',
  HKD: 'zh-HK',
  HUF: 'hu-HU',
  IDR: 'id-ID',
  INR: 'hi-IN',
  JPY: 'ja-JP',
  KES: 'en-KE',
  KRW: 'ko-KR',
  KWD: 'ar-KW',
  KZT: 'kk-KZ',
  LKR: 'si-LK',
  LSL: 'st-LS',
  MAD: 'ar-MA',
  MGA: 'mg-MG',
  MKD: 'mk-MK',
  MMK: 'my-MM',
  MNT: 'mn-MN',
  MOP: 'zh-MO',
  MXN: 'es-MX',
  MYR: 'ms-MY',
  MZN: 'pt-MZ',
  NGN: 'en-NG',
  NIO: 'es-NI',
  NOK: 'no-NO',
  NPR: 'ne-NP',
  NZD: 'en-NZ',
  PAB: 'es-PA',
  PEN: 'es-PE',
  PKR: 'ur-PK',
  PLN: 'pl-PL',
  PYG: 'es-PY',
  QAR: 'ar-QA',
  RMB: 'zh-CN',
  RSD: 'sr-RS',
  RUB: 'ru-RU',
  RWF: 'rw-RW',
  SAR: 'ar-SA',
  SEK: 'sv-SE',
  SLL: 'en-SL',
  SVC: 'es-SV',
  THB: 'th-TH',
  TND: 'ar-TN',
  TRY: 'tr-TR',
  TTD: 'en-TT',
  TWD: 'zh-TW',
  TZS: 'sw-TZ',
  UAH: 'uk-UA',
  UGX: 'en-UG',
  USD: 'en-US',
  UYU: 'es-UY',
  UZS: 'uz-UZ',
  VND: 'vi-VN',
  XAF: 'fr-CM',
  XOF: 'fr-SN',
  ZAR: 'en-ZA',
  ZWD: 'en-ZW',
  ZWL: 'en-ZW',
};

export const formatValue = (value: number, currency: string, maxDigits = 2): string => {
  const locale = locales[currency] || 'en-US';

  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDigits,
  }).format(value);
};
